// extracted by mini-css-extract-plugin
export default {"button":"lw_lx","badge":"lw_ly","loading":"lw_lz","rotate":"lw_gu","content":"lw_lA","button__main":"lw_lB","button__accent":"lw_lC"};